function n(o) {
  if (typeof document > "u")
    return;
  const t = o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), e = document.cookie.match(`(^|[^;]+)\\s*${t}\\s*=\\s*([^;]+)`);
  return e ? decodeURIComponent(e[2]) : void 0;
}
export {
  n as getCookie
};
